import { Edit, FilePlus } from "lucide-react"
import { Link } from "react-router-dom";

export default function FormOptions() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <main className="flex flex-1 flex-col items-center justify-center p-4 md:p-6">
        <div className="mx-auto w-full max-w-4xl">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">Form Management</h1>
            <p className="mt-2 text-slate-600">Choose an option to continue</p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {/* Edit Existing Form Option */}
            <Link to="edit">
              <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-all hover:border-slate-300 hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                  <Edit className="h-6 w-6 text-blue-600" />
                </div>
                <h2 className="mb-2 text-xl font-semibold text-slate-900">Edit Existing Form</h2>
                <p className="mb-4 flex-1 text-slate-500">
                  Modify, update, or review your previously created forms. Make changes to questions, settings, or
                  design.
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center text-sm font-medium text-blue-600">
                    Select a form to edit
                    <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </div>
            </Link>

            {/* Create New Form Option */}
            <Link to="new">
              <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-all hover:border-slate-300 hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                  <FilePlus className="h-6 w-6 text-green-600" />
                </div>
                <h2 className="mb-2 text-xl font-semibold text-slate-900">Create New Form</h2>
                <p className="mb-4 flex-1 text-slate-500">
                  Start from scratch and build a new form. Add questions, customize settings, and design your form to
                  meet your needs.
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center text-sm font-medium text-green-600">
                    Start creating
                    <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
